module.exports = __webpack_public_path__ + "static/media/Fornuis.33f10ea3.mp3";